import type { FieldMeta, ResourceMeta } from '../../types/resource';

/**
 * Editable fields, with `edit_via` display fields substituted by their
 * join-id sibling (bcm_name → bcm_id) so PATCH targets the writable
 * column while the label stays user-friendly.
 */
export function extractEditableFields(meta: ResourceMeta): FieldMeta[] {
  const fields = meta.view_meta?.fields ?? [];
  const byTitle = new Map(fields.map((f) => [f.title, f]));
  const editable = fields.filter((f) => f.editable === true);

  const seen = new Set<string>();
  const result: FieldMeta[] = [];
  for (const f of editable) {
    if (f.edit_via) {
      const via = byTitle.get(f.edit_via);
      if (via && !seen.has(via.title)) {
        result.push({ ...via, display_title: f.display_title || f.title });
        seen.add(via.title);
      }
      continue;
    }
    if (!seen.has(f.title)) {
      result.push(f);
      seen.add(f.title);
    }
  }
  return result;
}
